import { isValidPortalTemplateId } from '../theme/loginPortalThemes';
import { getStoredTemplate, setStoredTemplate } from './publicPortalPreferences';

const PAGE_KEY = 'erp4c_landing_page_template';
const PANELS_KEY = 'erp4c_landing_panels_template';
const CAREER_KEY = 'erp4c_landing_career_template';
const FEATURES_KEY = 'erp4c_landing_features_template';
const NAV_KEY = 'erp4c_landing_nav_variant';

/** @typedef {'auto'|'light'|'dark'} LandingNavVariant */

function readTemplate(key) {
  try {
    const v = localStorage.getItem(key);
    if (isValidPortalTemplateId(v)) return v;
  } catch {
    /* ignore */
  }
  return null;
}

function writeTemplate(key, id) {
  try {
    const v = isValidPortalTemplateId(id) ? id : 'dark';
    localStorage.setItem(key, v);
  } catch {
    /* ignore */
  }
}

export function getStoredLandingPageTemplate() {
  return readTemplate(PAGE_KEY) || getStoredTemplate();
}

export function setStoredLandingPageTemplate(id) {
  writeTemplate(PAGE_KEY, id);
}

export function getStoredLandingPanelsTemplate() {
  return readTemplate(PANELS_KEY) || getStoredLandingPageTemplate();
}

export function setStoredLandingPanelsTemplate(id) {
  writeTemplate(PANELS_KEY, id);
}

export function getStoredLandingCareerTemplate() {
  return readTemplate(CAREER_KEY) || getStoredLandingPageTemplate();
}

export function setStoredLandingCareerTemplate(id) {
  writeTemplate(CAREER_KEY, id);
}

export function getStoredLandingFeaturesTemplate() {
  return readTemplate(FEATURES_KEY) || getStoredLandingPageTemplate();
}

export function setStoredLandingFeaturesTemplate(id) {
  writeTemplate(FEATURES_KEY, id);
}

/** @returns {LandingNavVariant} */
export function getStoredLandingNavVariant() {
  try {
    const v = localStorage.getItem(NAV_KEY);
    if (v === 'light' || v === 'dark' || v === 'auto') return v;
  } catch {
    /* ignore */
  }
  return 'auto';
}

/** @param {LandingNavVariant} v */
export function setStoredLandingNavVariant(v) {
  try {
    localStorage.setItem(NAV_KEY, v === 'light' || v === 'dark' ? v : 'auto');
  } catch {
    /* ignore */
  }
}

/** Push landing page atmosphere to query portal + login default storage. */
export function syncLandingPageTemplateToPortal(pageTemplateId) {
  if (!isValidPortalTemplateId(pageTemplateId)) return;
  setStoredTemplate(pageTemplateId);
  try {
    localStorage.setItem('loginTheme', pageTemplateId);
  } catch {
    /* ignore */
  }
}

export function resetLandingAppearanceToDefaults() {
  const def = 'dark';
  setStoredLandingPageTemplate(def);
  setStoredLandingPanelsTemplate(def);
  setStoredLandingCareerTemplate(def);
  setStoredLandingFeaturesTemplate(def);
  setStoredLandingNavVariant('auto');
}
